import React, { useContext, useEffect } from 'react';
import './Error404Page.less';
import { CustomAppContext } from '../common/CustomAppContext';
import { Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { trackCustomEvent } from '../helpers';

export default Error404Page;

/**
 * @name Error404Page
 * @desc component.
 */
function Error404Page() {
    const { currentApp, getCustomAppPath } = useContext(CustomAppContext);

    const history = useHistory();

    const handleGoHome = () => {
        history.push(getCustomAppPath('/'));
        trackCustomEvent(currentApp, 'user_signup_clicked', 'click');
    };

    const handleRegistrationClick = () => {
        history.push(getCustomAppPath('/register'));
        trackCustomEvent(currentApp, 'user_signup_clicked', 'click');
    };

    return (
        <div className="Error404Page-details">
            <h1>Page not found</h1>
            <p>
                The content you're looking for doesn't exist. Either it was
                removed, or you mistyped the link.
            </p>

            <div className="Error404Page-buttons">
                <Button
                    data-testid="forgot-password-form-button-back"
                    htmlType="button"
                    onClick={handleRegistrationClick}
                    className="Error404Page-button-signup"
                >
                    Sign up
                </Button>
                <Button
                    type="primary"
                    onClick={handleGoHome}
                    className="Error404Page-button-home"
                >
                    Go to home
                </Button>
            </div>
        </div>
    );
}
